import React from "react";
import { COLORS, FONTS } from "./constants";
import { TrustCard, Tag } from "./TrustCard";
import { glow } from "./shared";

// Diagrams that render — technical diagrams that include file paths and
// function names now draw correctly instead of failing to parse. Before: a
// broken render. After: a clean flow diagram.
export const Scene9Diagrams: React.FC = () => {
  const before = (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{
        flex: 1, borderRadius: 16,
        border: `2px dashed ${COLORS.neonRed}88`,
        background: `${COLORS.neonRed}0c`,
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: 16, padding: 24,
      }}>
        <div style={{ fontSize: 60 }}>⚠️</div>
        <div style={{ fontSize: 26, fontFamily: FONTS.heading, fontWeight: 800, color: COLORS.neonRed }}>
          Diagram failed to render
        </div>
        <div style={{
          fontSize: 18, fontFamily: FONTS.mono, color: COLORS.textMuted,
          textAlign: "center", lineHeight: 1.5,
        }}>
          Parse error near "batch_runner.py()"
        </div>
      </div>
      <div style={{ marginTop: 22 }}>
        <Tag color={COLORS.neonOrange} text="Paths & function names broke the parser" />
      </div>
    </div>
  );

  const after = (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{
        flex: 1, display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center", gap: 8,
      }}>
        <DiagNode label="batch_runner.py" c={COLORS.neonPurple} />
        <DiagArrow />
        <DiagNode label="workerPool()" c={COLORS.neonCyan} />
        <DiagArrow />
        <DiagNode label="redis.streams" c={COLORS.neonPink} />
      </div>
      <div style={{ marginTop: 22 }}>
        <Tag color={COLORS.neonGreen} text="Draws correctly, paths and all" />
      </div>
    </div>
  );

  return (
    <TrustCard
      accent={COLORS.neonPurple}
      index="3 / 4"
      title="Diagrams that render"
      subtitle="Diagrams with file paths and function names now draw instead of breaking."
      before={before}
      after={after}
    />
  );
};

const DiagNode: React.FC<{ label: string; c: string }> = ({ label, c }) => (
  <div style={{
    fontSize: 24, fontFamily: FONTS.mono, fontWeight: 700, color: c,
    padding: "14px 30px", borderRadius: 12,
    background: `${c}14`, border: `2px solid ${c}`,
    boxShadow: `0 0 26px ${c}55`, textShadow: glow(c),
  }}>
    {label}
  </div>
);

const DiagArrow: React.FC = () => (
  <div style={{ fontSize: 30, color: COLORS.neonGreen, textShadow: glow(COLORS.neonGreen), lineHeight: 1 }}>
    ↓
  </div>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
